"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var fragmentRenderer = {
  root: function root(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  },
  paragraph: function paragraph(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
};
fragmentRenderer.root.propTypes = propTypes;
fragmentRenderer.paragraph.propTypes = propTypes;
var _default = fragmentRenderer;
exports["default"] = _default;